import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Plus } from "@opendate-app/setlist";
import { useSeriesShowContext } from "../SeriesShowApp";

// "Sell passes for this series" makes a collection that includes the series and
// lands on its Passes & Packs tab. The server sends can_start_pass_collection only
// when collections and passes are both switched on, so this never leads to a 404.
const SellPassesButton = ({ variant = "primary" }) => {
  const { series, canManageSeries, handleStartPassCollection } = useSeriesShowContext();
  const [starting, setStarting] = useState(false);

  if (!series.can_start_pass_collection || canManageSeries === false) return null;

  const start = async () => {
    setStarting(true);
    const started = await handleStartPassCollection();
    if (!started) setStarting(false);
  };

  return (
    <Button
      variant={variant}
      icon={Plus}
      data-testid="sell-passes-for-series-btn"
      disabled={starting}
      onClick={start}
    >
      Sell passes for this series
    </Button>
  );
};

SellPassesButton.propTypes = {
  variant: PropTypes.string,
};

export default SellPassesButton;
